// Updating calypso from Partners. A satellite carries agent_update:
// { latest_version, available, remote, status: "pending" | "failed" | null, target_version, requested_at, error }.

// The update can be requested now: a newer release is out, the agent can update itself and is online.
export function canRequestAgentUpdate(satellite) {
  const update = satellite && satellite.agent_update;
  return !!update && update.available && update.remote && update.status !== "pending" && satellite.status === "online";
}
